export default "__VITE_ASSET__44a2bbe7__"